// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"8ded6f56","498":"c7b9ab65","703":"d6d4a015"}[chunkId] + ".chunk.js";
};